<template>
    <BaseField class="integer-field" fieldClass="integer-base-field" overflow v-bind="$props" v-on="$listeners">
        <input
            type="number"
            class="value-field"
            :placeholder="placeholder"
            :value="value"
            @input="onInput"
            step="1"
            min="1"
        />
        <template v-slot:afterInput>
            <slot name="afterInput"></slot>
        </template>
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';

export default {
    name: 'IntegerField',
    components: { BaseField },
    props: {
        ...BaseField.props,
        value: Number,
        placeholder: {
            type: String,
            default: 'Number'
        }
    },
    methods: {
        onInput(event) {
            const value = event.target.valueAsNumber;
            const valueString = event.target.value;

            if (valueString === '') {
                this.$emit('update:value', null);
                return;
            }

            // this is emitted to trigger a change in vue (if the value was 1, and then '-' was entered,
            // we emit 1, which doesn't trigger a change as both the old an new values are 1, leaving the text '-'
            this.$emit('update:value', -1);
            this.$emit('update:value', (!Number.isNaN(value) && value !== 0) ? Number.parseInt(value, 10) : 1);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/input.scss";

input[type="number"] {
    width: 80px;
    padding-right: 0;
}

.integer-field ::v-deep .integer-base-field {
    max-width: 100px;
}
</style>
